import React, { ReactNode } from 'react'
import classes from './MenuItem.module.scss'
import { MenuItem as MuiMenuItem, MenuItemOwnProps } from '@mui/base/MenuItem'
import { ReactComponent as ArrowIcon } from '@/assets/icons/chevron-right.svg'
import { useMenuItemSlotProps } from '@/components/ui/Menu/Menu.hooks'

export type MenuItemProps = MenuItemOwnProps & { StartIcon?: ReactNode; isArrowVisible?: boolean }

const MenuItem = ({ children, StartIcon, isArrowVisible = true, ...props }: MenuItemProps) => {
  const slotProps = useMenuItemSlotProps()

  return (
    <MuiMenuItem slotProps={slotProps} {...props}>
      {StartIcon && <div className={classes.startIcon}>{StartIcon}</div>}
      <div className={classes.title}>{children}</div>
      {isArrowVisible && (
        <div className={classes.endIcon}>
          <ArrowIcon />
        </div>
      )}
    </MuiMenuItem>
  )
}

export default MenuItem
